var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIconHoverBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.97968 2.2519L3.41794 7.36494C2.32229 8.21711 1.43359 10.031 1.43359 11.4067L1.43359 20.4275C1.43359 23.2519 3.73446 25.5649 6.55881 25.5649L20.6562 25.5649C23.4806 25.5649 25.7814 23.2519 25.7814 20.4397L25.7814 11.5771C25.7814 10.1041 24.7953 8.21711 23.5901 7.37711L16.0666 2.10581C14.3623 0.912765 11.6232 0.973634 9.97968 2.2519Z",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.6094 20.6956V17.0435",
    stroke: "#0008C3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconHoverBlue);
export default __webpack_public_path__ + "static/media/homeIconHoverBlue.5721f4206a8e79186baaafc5e92ee6ec.svg";
export { ForwardRef as ReactComponent };